export const TEST_DISPATCH = "TEST_DISPATCH";

export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const SET_STATUS_MESSAGE = "SET_STATUS_MESSAGE";
export const CLEAR_STATUS_MESSAGE = "CLEAR_STATUS_MESSAGE";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_IS_LOADING = "SET_IS_LOADING";

export const SET_CURRENT_DEALS = "SET_CURRENT_DEALS";
export const SET_DOMAIN_DATA = "SET_DOMAIN_DATA";

export const MODIFY_ACCOMMODATION = "MODIFY_ACCOMMODATION";
export const DELETE_ACCOMMODATION = "DELETE_ACCOMMODATION";
export const INSERT_ACCOMMODATION = "INSERT_ACCOMMODATION";
export const DELETE_ACCOMMODATIONS_FOR_PROPERTY = "DELETE_ACCOMMODATIONS_FOR_PROPERTY";
export const CHANGE_ACCOMMODATION_STATUS = "CHANGE_ACCOMMODATION_STATUS";



export const SET_CURRENT_ACCOMMODATIONS = "SET_CURRENT_ACCOMMODATIONS";

export const MODIFY_PROPERTY = "MODIFY_PROPERTY";
export const INSERT_PROPERTY = "INSERT_PROPERTY";
export const DELETE_PROPERTY = "DELETE_PROPERTY";
export const CHANGE_PROPERTY_STATUS = "CHANGE_PROPERTY_STATUS";



export const SET_CURRENT_PROPERTIES = "SET_CURRENT_PROPERTIES";






/*
export const SET_CURRENT_ADVERTISEMENTS = "SET_CURRENT_ADVERTISEMENTS";
export const SET_CURRENT_ADVERTISEMENT = "SET_CURRENT_ADVERTISEMENT";
export const CREATE_ADVERTISEMENT = "CREATE_ADVERTISEMENT";
export const MODIFY_ADVERTISEMENT = "MODIFY_ADVERTISEMENT";
export const REMOVE_ADVERTISEMENT = "REMOVE_ADVERTISEMENT";
export const CHANGE_ADVERTISEMENT_STATUS = "CHANGE_ADVERTISEMENT_STATUS";

export const SET_BUSINESSES = "SET_BUSINESSES";
export const SET_IMAGES = "SET_IMAGES";
export const SET_NEW_IMAGE = "SET_NEW_IMAGE";
export const REMOVE_IMAGE = "REMOVE_IMAGE";

export const CHANGE_BUSINESS_STATUS = "CHANGE_BUSINESS_STATUS";
export const REMOVE_BUSINESS = "REMOVE_BUSINESS";
export const CREATE_BUSINESS = "CREATE_BUSINESS";
export const MODIFY_BUSINESS = "MODIFY_BUSINESS";
export const SET_BUSINESS = "SET_BUSINESS";

export const SET_ADVERTISERS = "SET_ADVERTISERS";
export const CHANGE_ADVERTISER_STATUS = "CHANGE_ADVERTISER_STATUS";
export const REMOVE_ADVERTISER = "REMOVE_ADVERTISER";
*/


// export const GET_PROFILE = "GET_PROFILE";
// export const PROFILE_LOADING = "PROFILE_LOADING";
// export const PROFILE_NOT_FOUND = "PROFILE_NOT_FOUND";
// export const CLEAR_CURRENT_PROFILE = "CLEAR_CURRENT_PROFILE";
// export const GET_PROFILES = "GET_PROFILES";
// export const POST_LOADING = "POST_LOADING";
// export const GET_POSTS = "GET_POSTS";
// export const GET_POST = "GET_POST";
// export const ADD_POST = "ADD_POST";
// export const DELETE_POST = "DELETE_POST";








// WEBPACK FOOTER //
// ./src/actions/types.js